<template>
  <v-app id="inspire" v-resize="checkMobile">
    <loading :active.sync="isLoading" :is-full-page="true" color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"></loading>
    <v-main v-if="booking == null" class="mt-auto">
      <v-alert v-if="error" :value="true" color="error">
        {{ error }}
      </v-alert>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>{{ $t("users.enter") }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form @submit.prevent="findBooking()">
                  <v-text-field v-model.trim="last_name" :label="$t('bookings.lastname')" required></v-text-field>
                  <v-text-field v-model.trim="booking_id" :label="$t('bookings.booking_number')"
                    required></v-text-field>
                  <v-flex class="text-center">
                    <v-btn type="submit" block color="primary">{{ $t("users.enter") }}</v-btn>
                  </v-flex>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <v-card v-else>
      <v-toolbar text :color="$vuetify.theme.dark ? '' : 'white'">
        <v-toolbar-title class="text-h5">
          {{ $t("bookings.booking_number") }} {{ booking.id }} - {{ translateBookingState(booking.state) }}
          <v-btn icon @click="downloadIcalendar(booking.id)" v-tooltip="{
            content: $t('tooltips.download_icalendar'),
            placement: 'bottom-center',
            classes: ['black--text', 'white'],
            targetClasses: ['it-has-a-tooltip'],
            delay: { show: 500, hide: 500 },
          }">
            <v-icon>mdi-calendar-export</v-icon>
          </v-btn>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-flex md12 :class="isMobile ? 'mx-3' : 'd-flex mx-3'">
          <v-flex xs12 md4 class="start-tour-booking-2">
            <v-card outlined>
              <v-card-title class="text-h6 py-2">
                <v-icon left>mdi-file-document-outline</v-icon>
                {{ $t("bookings.booking_info") }}
              </v-card-title>
              <v-divider></v-divider>
              
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr v-if="booking.vseprokaty_id">
                      <td class="text-left font-weight-medium">{{ $t("agregator.agregator_id") }}</td>
                      <td class="text-right">{{ booking.vseprokaty_id }}</td>
                    </tr>
                    <tr v-if="booking.fast_booking">
                      <td class="text-left font-weight-medium">{{ $t("agregator.fast_booking") }}</td>
                      <td class="text-right">+</td>
                    </tr>
                    <tr v-if="booking.vseprokaty_id && !booking.fast_booking">
                      <td class="text-left font-weight-medium">{{ $t("agregator.fast_booking") }}</td>
                      <td class="text-right">-</td>
                    </tr>
                    <tr v-else>
                      <td class="text-left font-weight-medium">{{ $t("custom.created") }}</td>
                      <td class="text-right">{{ formatCreatedAt(booking.created_at) }}</td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium">{{ $t("custom.car_long", { msg: object_name_for_label }) }}</td>
                      <td class="text-right">{{ booking.car_name }}</td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium">{{ $t("bookings.start_date") }}</td>
                      <td class="text-right">{{ booking.start_date }}</td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium">{{ $t("bookings.end_date") }}</td>
                      <td class="text-right">{{ booking.end_date }}</td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium">{{ $t("custom.days") }}</td>
                      <td class="text-right">{{ booking.days }}</td>
                    </tr>
                    <tr v-if="booking.additional_hours > 0">
                      <td class="text-left font-weight-medium">{{ $t("bookings.add_hours") }}</td>
                      <td class="text-right">{{ booking.additional_hours }}</td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium">{{ $t("bookings.checkin") }}</td>
                      <td class="text-right">{{ booking.location_start }}</td>
                    </tr>
                    <tr>
                      <td class="text-left font-weight-medium">{{ $t("bookings.checkout") }}</td>
                      <td class="text-right">{{ booking.location_end }}</td>
                    </tr>
                    <tr v-if="!booking.technical">
                      <td class="text-left font-weight-medium">{{ $t("bookings.current_price") }}</td>
                      <td class="text-right">{{ Math.round(booking.rental_cost / booking.days) }} {{ findCurrencySymbol(base_currency_id) }}</td>
                    </tr>
                    <tr v-if="!booking.technical && booking.sale_cash">
                      <td class="text-left font-weight-medium">{{ $t("bookings.sale") }}</td>
                      <td class="text-right">{{ booking.sale_cash }} {{ findCurrencySymbol(base_currency_id) }}</td>
                    </tr>
                    <tr v-if="!booking.technical && booking.sale">
                      <td class="text-left font-weight-medium">{{ $t("bookings.sale") }}</td>
                      <td class="text-right">{{ booking.sale }}%</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              
              <!-- Дополнительное оборудование -->
              <template v-if="booking.chair || booking.chair_less_1_year || booking.booster || booking.navigator || booking.mp3 || booking.charger || booking.wifi_router || booking.other_equipment">
                <v-divider></v-divider>
                <v-subheader class="font-weight-bold grey lighten-4" :class="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'">
                  {{ $t("bookings.add_equipment") }}
                </v-subheader>
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr v-if="booking.chair">
                        <td class="text-left">{{ $t("bookings.baby_chair") }}</td>
                        <td class="text-right">{{ booking.chairs_quantity }}</td>
                      </tr>
                      <tr v-if="booking.chair_less_1_year">
                        <td class="text-left">{{ $t("bookings.small_baby_chair") }}</td>
                        <td class="text-right">{{ booking.chairs_quantity }}</td>
                      </tr>
                      <tr v-if="booking.booster">
                        <td class="text-left">{{ $t("bookings.booster") }}</td>
                        <td class="text-right">{{ booking.boosters_quantity }}</td>
                      </tr>
                      <tr v-if="booking.navigator">
                        <td class="text-left" colspan="2">{{ $t("bookings.navigator") }}</td>
                      </tr>
                      <tr v-if="booking.mp3">
                        <td class="text-left" colspan="2">{{ $t("bookings.mp3") }}</td>
                      </tr>
                      <tr v-if="booking.charger">
                        <td class="text-left" colspan="2">{{ $t("bookings.charger") }}</td>
                      </tr>
                      <tr v-if="booking.wifi_router">
                        <td class="text-left" colspan="2">{{ $t("bookings.wifi") }}</td>
                      </tr>
                      <tr v-if="booking.other_equipment">
                        <td class="text-left" colspan="2">{{ booking.other_equipment }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>
              
              <!-- Страховки -->
              <template v-if="booking.kasko || booking.super_kasko || booking.theft || booking.no_franchise">
                <v-divider></v-divider>
                <v-subheader class="font-weight-bold" :class="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4 black--text'">
                  {{ $t("bookings.add_insurance") }}
                </v-subheader>
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr v-if="booking.kasko">
                        <td class="text-left" colspan="2">{{ $t("bookings.kasko") }}</td>
                      </tr>
                      <tr v-if="booking.super_kasko">
                        <td class="text-left" colspan="2">{{ $t("bookings.super_kasko") }}</td>
                      </tr>
                      <tr v-if="booking.theft">
                        <td class="text-left" colspan="2">{{ $t("bookings.theft_insurance") }}</td>
                      </tr>
                      <tr v-if="booking.no_franchise">
                        <td class="text-left" colspan="2">{{ $t("bookings.no_franchise") }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>
              
              <!-- Расчёт -->
              <template v-if="!booking.technical">
                <v-divider></v-divider>
                <v-subheader class="font-weight-bold" :class="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4 black--text'">
                  {{ $t("bookings.calculate") }}
                </v-subheader>
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr v-if="booking.aggr_commission == 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.rental_cost") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.rental_cost }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr v-if="booking.hours_cost > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.hours_cost") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.hours_cost }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr v-if="booking.hours_cost_end > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.hours_cost_end") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.hours_cost_end }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr v-if="booking.delivery > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.delivery") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.delivery }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr v-if="booking.delivery_end > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.checkout") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.delivery_end }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <!-- UAT 2026-08-07: рядом с каталожными допами FT-102 легаси-сумма
                           называется «Другое оборудование» — иначе две одинаковые строки -->
                      <tr v-if="booking.equipment > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.other_equipment") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.equipment }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <!-- FT-102: каталожное оборудование -->
                      <tr v-if="booking.addons_cost > 0">
                        <td class="text-left font-weight-bold">{{ $t("booking_addons.title") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.addons_cost }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr v-if="booking.clean_payment > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.clean") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.clean_payment }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr v-if="booking.damage > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.damages") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.damage }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr v-if="booking.gas > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.for_gas") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.gas }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr v-if="booking.add_drivers_cost > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.for_add_drivers") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.add_drivers_cost }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr v-if="booking.insurance > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.for_add_insurance") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.insurance }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr v-if="booking.fine > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.for_fines") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.fine }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr v-if="booking.other > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.for_other") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.other }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr v-if="booking.other_end > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.for_other_end") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.other_end }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr v-if="booking.mileage_cost > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.mileage_cost") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.mileage_cost }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr v-if="booking.aggr_commission > 0">
                        <td class="text-left font-weight-bold">{{ $t("bookings.aggr_commission") }}</td>
                        <td class="text-right font-weight-bold">{{ booking.aggr_commission }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr>
                        <td class="text-left font-weight-bold">{{ $t("bookings.deposit") }}</td>
                        <td class="text-right font-weight-bold">{{ bookingDeposit(booking) }} {{ findCurrencySymbol(base_currency_id) }}</td>
                      </tr>
                      <tr :class="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-3'">
                        <td class="text-left text-h6 font-weight-bold">{{ $t("custom.total") }}</td>
                        <td class="text-right text-h6 font-weight-bold">
                          <!-- Состав слагаемых обязан совпадать с ЧИПОМ оплаты на этой же
                               странице и с серверным BOOKING_COST_SUM_SQL: они включают
                               hours_cost/hours_cost_end для ВСЕХ типов аренды. Здесь нельзя
                               звать bookingIncome() из timelineTotals — та формула считает
                               «приход дня» и у почасовой брони часы намеренно опускает
                               (легаси-поведение таймлайна). Подмена уводила «Итого» от
                               сервера и от соседнего чипа (финальное ревью 2026-08-24).
                               По типу берётся только ЗАЛОГ. -->
                          {{
                            booking.rental_cost +
                            booking.delivery +
                            booking.delivery_end +
                            booking.equipment +
                            (booking.addons_cost || 0) +
                            booking.insurance +
                            booking.clean_payment +
                            booking.add_drivers_cost +
                            booking.hours_cost +
                            booking.mileage_cost +
                            booking.damage +
                            booking.gas +
                            booking.fine +
                            booking.other +
                            booking.other_end +
                            booking.hours_cost_end +
                            bookingDeposit(booking)
                          }} {{ findCurrencySymbol(base_currency_id) }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>
              
              <!-- Оплачено -->
              <template v-if="!booking.technical">
                <v-divider></v-divider>
                <v-card-text class="py-2">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <div :class="'text-h6 font-weight-bold ' + (calculatePayments(booking) == $t('bookings.paid') ? 'success--text' : 'error--text')">
                        {{ $t("bookings.paid") }}: {{ calculatePaymentsSum(booking) }} {{ findCurrencySymbol(base_currency_id) }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </template>
              
              <!-- Прогресс оплаты дней -->
              <template v-if="calculateRentPaymentsSum(booking) > 0 && booking.rental_cost > 0 && booking.days > 0">
                <v-divider></v-divider>
                <v-card-text class="py-3">
                  <v-progress-linear :value="progressPercent" :color="progressPercent == 100 ? 'success' : 'warning'" rounded height="25" class="mb-1">
                    <strong class="white--text">{{ paidDays }} {{ $t("other.from") }} {{ booking.days }} {{ $tc("bookings.days_plural", booking.days) }}</strong>
                  </v-progress-linear>
                </v-card-text>
              </template>
              
              <!-- Данные выдачи/приёмки -->
              <template v-if="booking.in_rent || booking.ride || booking.start_mileage > 0 || booking.end_mileage > 0">
                <v-divider></v-divider>
                <v-subheader class="font-weight-bold" :class="$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4 black--text'">
                  {{ $t("bookings.car_condition") }}
                </v-subheader>
                <v-simple-table dense>
                  <template v-slot:default>
                    <tbody>
                      <tr v-if="booking.in_rent || booking.ride">
                        <td class="text-left">{{ $t("bookings.clean_start") }}</td>
                        <td class="text-right">
                          <v-icon small :color="booking.clean_start ? 'green' : 'red'">
                            {{ booking.clean_start ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                        </td>
                      </tr>
                      <tr v-if="booking.ride">
                        <td class="text-left">{{ $t("bookings.clean_end") }}</td>
                        <td class="text-right">
                          <v-icon small :color="booking.clean_end ? 'green' : 'red'">
                            {{ booking.clean_end ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                        </td>
                      </tr>
                      <tr v-if="(booking.in_rent || booking.ride) && !booking.gas_start_full">
                        <td class="text-left">{{ $t("bookings.gas_start") }}</td>
                        <td class="text-right">{{ booking.gas_start }}</td>
                      </tr>
                      <tr v-if="(booking.in_rent || booking.ride) && booking.gas_start_full">
                        <td class="text-left" colspan="2">{{ $t("bookings.gas_start_full") }}</td>
                      </tr>
                      <tr v-if="!booking.gas_end_full && booking.ride">
                        <td class="text-left">{{ $t("bookings.gas_end_short") }}</td>
                        <td class="text-right">{{ booking.gas_end }}</td>
                      </tr>
                      <tr v-if="booking.gas_end_full && booking.ride">
                        <td class="text-left" colspan="2">{{ $t("bookings.gas_end_full") }}</td>
                      </tr>
                      <tr v-if="(booking.in_rent || booking.ride) && booking.start_mileage > 0">
                        <td class="text-left">{{ $t("bookings.mileage_start") }}</td>
                        <td class="text-right">{{ booking.start_mileage }} {{ $t("custom.km") }}</td>
                      </tr>
                      <tr v-if="booking.end_mileage > 0">
                        <td class="text-left">{{ $t("bookings.mileage_end") }}</td>
                        <td class="text-right">{{ booking.end_mileage }} {{ $t("custom.km") }}</td>
                      </tr>
                      <tr v-if="booking.booking_mileage > 0">
                        <td class="text-left">{{ $t("bookings.booking_mileage") }}</td>
                        <td class="text-right">{{ booking.booking_mileage }} {{ $t("custom.km") }}</td>
                      </tr>
                      <tr v-if="booking.booking_mileage > 0">
                        <td class="text-left">{{ $t("bookings.average_mileage") }}</td>
                        <td class="text-right">{{ Math.trunc(booking.booking_mileage / booking.days) }} {{ $t("bookings.km_day") }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>
            </v-card>
          </v-flex>
          <div xs12 md1 class="vl"></div>
          <v-flex xs12 md4 class="mt-2">
            <v-card class="mb-4">
              <v-card-title class="text-h6 py-2">
                <v-icon left>mdi-cash-multiple</v-icon>
                {{ $t("bookings.counts_and_prolongs") }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <h2 v-if="booking.counts && booking.counts.length == 0" class="text-center">
                {{ $t("bookings.no_payments_for_this_booking") }}
                </h2>
                <v-expansion-panels v-if="booking.counts && booking.counts.length != 0" v-model="paymentsPanel"
                  class="start-tour-booking-3">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <h2 class="mb-0 d-flex">
                        {{ $t("bookings.counts") }}
                      </h2>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table dense>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-center">
                                {{ $t("custom.date") }}
                              </th>
                              <th class="text-center">
                                {{ $t("custom.sum") }}
                              </th>
                              <th class="text-center">
                                {{ $t("custom.type") }}
                              </th>
                              <th class="text-center">
                                {{ $t("custom.group") }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="count in booking.counts" :key="count.index"
                              :class="count.operation ? '' : 'red--text'">
                              <td class="text-center">
                                {{ formatCreatedAt(count.created_at) }}
                              </td>
                              <td class="text-center">
                                {{ count.operation ? "" : "-" }}{{ count.sum
                                }}
                              </td>
                              <td class="text-center" v-if="count.cash">
                                <v-icon class="text-center" color="success" v-tooltip="{
                                  content: $t('money.cash'),
                                  placement: 'bottom-center',
                                  classes: ['info'],
                                  targetClasses: ['it-has-a-tooltip'],
                                  delay: {
                                    show: 500,
                                    hide: 500,
                                  },
                                }">
                                  mdi-cash
                                </v-icon>
                              </td>
                              <td class="text-center" v-if="count.cashless">
                                <v-icon class="text-center" color="warning" v-tooltip="{
                                  content: $t('money.terminal'),
                                  placement: 'bottom-center',
                                  classes: ['info'],
                                  targetClasses: ['it-has-a-tooltip'],
                                  delay: {
                                    show: 500,
                                    hide: 500,
                                  },
                                }">
                                  mdi-contactless-payment-circle-outline
                                </v-icon>
                              </td>
                              <td class="text-center" v-if="count.entity">
                                <v-icon class="text-center" color="secondery" v-tooltip="{
                                  content: $t('money.to_entity'),
                                  placement: 'bottom-center',
                                  classes: ['info'],
                                  targetClasses: ['it-has-a-tooltip'],
                                  delay: {
                                    show: 500,
                                    hide: 500,
                                  },
                                }">
                                  mdi-bank
                                </v-icon>
                              </td>
                              <td class="text-center" v-if="count.cash_card">
                                <v-icon class="text-center" color="info" v-tooltip="{
                                  content: $t('money.card_to_card'),
                                  placement: 'bottom-center',
                                  classes: ['info'],
                                  targetClasses: ['it-has-a-tooltip'],
                                  delay: {
                                    show: 500,
                                    hide: 500,
                                  },
                                }">
                                  mdi-credit-card-check-outline
                                </v-icon>
                              </td>
                              <td class="text-center" v-if="count.client_balance">
                                <v-icon class="text-center" color="error" v-tooltip="{
                                  content: $t('money.client_balance'),
                                  placement: 'bottom-center',
                                  classes: ['info'],
                                  targetClasses: ['it-has-a-tooltip'],
                                  delay: {
                                    show: 500,
                                    hide: 500,
                                  },
                                }">
                                  mdi-account-arrow-right
                                </v-icon>
                              </td>
                              <td class="text-center">
                                {{ translateCategory(count.group) }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <!-- Продления -->
                <v-expansion-panels v-if="booking.prolongs && booking.prolongs.length != 0" v-model="prolongsPanel"
                  class="mt-2">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <h2 class="mb-0 d-flex">
                        {{ $t("bookings.prolongs") }}
                      </h2>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table dense>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-center">
                                {{ $t("bookings.date_prolong") }}
                              </th>
                              <th class="text-center">
                                {{ $t("custom.days") }}
                              </th>
                              <th class="text-center">
                                {{ $t("bookings.price") }}
                              </th>
                              <th class="text-center">
                                {{ $t("custom.total") }}
                              </th>
                              <th class="text-center"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="prolong in booking.prolongs" :key="prolong.index">
                              <td class="text-center">
                                {{ formatPrologDate(prolong.last_date) }}
                              </td>
                              <td class="text-center">
                                {{ prolong.prolong_days }}
                              </td>
                              <td class="text-center">
                                {{ prolong.new_price }}
                              </td>
                              <td class="text-center">
                                {{ prolong.new_price * prolong.prolong_days
                                }}
                              </td>
                              <td class="text-center">

                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <!-- Подарки -->
                <v-expansion-panels v-if="booking.gifts && booking.gifts.length != 0" v-model="giftsPanel" class="mt-2">
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <h2 class="mb-0 d-flex">
                        {{ $t("gifts.title") }}
                      </h2>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-simple-table dense>
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-center">
                                {{ $t("gifts.created") }}
                              </th>
                              <th class="text-center">
                                {{ $t("gifts.type") }}
                              </th>
                              <th class="text-center">
                                {{ $t("gifts.count_short") }}
                              </th>
                              <th class="text-center">
                                {{ $t("bookings.price") }}
                              </th>
                              <th class="text-center"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="gift in booking.gifts" :key="gift.index">
                              <td class="text-center">
                                {{ formatPrologDate(gift.created_at) }}
                              </td>
                              <td class="text-center">
                                {{
                                  gift.gift_type == 0
                                    ? $t("gifts.days")
                                    : $t("gifts.hours")
                                }}
                              </td>
                              <td class="text-center">
                                {{ gift.count }}
                              </td>
                              <td class="text-center">
                                {{ gift.price }}
                              </td>
                              <td class="text-center">
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>
          </v-flex>
          <div xs12 md1 class="vl"></div>
          <v-flex xs12 md3 class="mx-auto start-tour-booking-4">
            <v-card outlined class="mb-4">
              <v-card-title class="text-h6">
                <v-icon left>mdi-account-cog</v-icon>
                {{ $t('clients.management') }}
              </v-card-title>
              <v-divider></v-divider>
              
              <v-card-text v-if="client && client.balance !== undefined">
                <div class="text-center mb-3">
                  <div class="caption text--secondary mb-1">{{ $t('other.balance') }}</div>
                  <div class="text-h4 font-weight-bold" :class="parseFloat(client.balance) >= 0 ? 'success--text' : 'error--text'">
                    {{ parseFloat(client.balance || 0).toFixed(2) }} {{ findCurrencySymbol(base_currency_id) }}
                  </div>
                </div>
                
                <div class="d-flex flex-column">
                  <v-btn
                    v-if="yandexPayAvailable"
                    color="error"
                    outlined
                    block
                    class="mb-2"
                    @click="openYandexPayDialog"
                  >
                    <v-icon left>mdi-alpha-y-circle</v-icon>
                    {{ $t('yandex_pay.pay_with_yandex') }}
                  </v-btn>
                  
                  <stripe-payment-dialog-public
                    v-if="client && client.id && booking && booking.id && stripeAvailable"
                    ref="stripePaymentDialog"
                    :client="client"
                    :company="company"
                    :currency="currency"
                    :booking-id="booking.id"
                    :last-name="last_name"
                    @payments-updated="handleStripePaymentsUpdated"
                  />
                </div>
                <div>
                  <!-- Все платежи -->
                  <v-expansion-panels v-if="(stripe_payments && stripe_payments.length > 0) || (yandex_pay_payments && yandex_pay_payments.length > 0) || (tinkoff_payments && tinkoff_payments.length > 0)" v-model="allPaymentsPanel" class="mt-2">
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <h2 class="mb-0 d-flex">
                          {{ $t("bookings.all_payments") }}
                        </h2>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <!-- Stripe платежи -->
                        <div v-if="stripe_payments && stripe_payments.length > 0" class="mb-4">
                          <h3 class="subtitle-1 mb-2 d-flex align-center">
                            <v-icon color="primary" class="mr-2">mdi-alpha-s-circle-outline</v-icon>
                            Stripe
                          </h3>
                          <v-card v-for="payment in stripe_payments" :key="'stripe-' + payment.id" outlined class="mb-2">
                            <v-card-text class="py-2">
                              <div class="d-flex justify-space-between align-center">
                                <div>
                                  <div class="subtitle-2">{{ formatAmount(payment.amount) }}</div>
                                  <div class="caption text--secondary">{{ formatDate(payment.created_at) }}</div>
                                </div>
                                <v-chip small :color="getStripeStatusColor(payment.status)" dark>
                                  {{ translateStripeStatus(payment.status) }}
                                </v-chip>
                              </div>
                              <div v-if="payment.refunded_amount > 0" class="caption error--text mt-1">
                                {{ $t('stripe_payment.refunded') }}: {{ formatAmount(payment.refunded_amount) }}
                              </div>
                            </v-card-text>
                          </v-card>
                        </div>

                        <!-- Yandex Pay платежи -->
                        <div v-if="yandex_pay_payments && yandex_pay_payments.length > 0" class="mb-4">
                          <h3 class="subtitle-1 mb-2 d-flex align-center">
                            <v-icon color="error" class="mr-2">mdi-alpha-y-circle</v-icon>
                            Yandex Pay
                          </h3>
                          <v-card v-for="payment in yandex_pay_payments" :key="'yandex-' + payment.id" outlined class="mb-2">
                            <v-card-text class="py-2">
                              <div class="d-flex justify-space-between align-center">
                                <div>
                                  <div class="subtitle-2">{{ formatAmount(payment.amount) }}</div>
                                  <div class="caption text--secondary">{{ formatDate(payment.created_at) }}</div>
                                </div>
                                <v-chip small :color="getYandexPayStatusColor(payment.status)" dark>
                                  {{ translateYandexPayStatus(payment.status) }}
                                </v-chip>
                              </div>
                              <div v-if="payment.refunded_amount > 0" class="caption error--text mt-1">
                                {{ $t('yandex_pay.refunded') }}: {{ formatAmount(payment.refunded_amount) }}
                              </div>
                            </v-card-text>
                          </v-card>
                        </div>

                        <!-- Tinkoff платежи -->
                        <div v-if="tinkoff_payments && tinkoff_payments.length > 0">
                          <h3 class="subtitle-1 mb-2 d-flex align-center">
                            <v-icon color="warning" class="mr-2">mdi-credit-card</v-icon>
                            Tinkoff
                          </h3>
                          <v-card v-for="payment in tinkoff_payments" :key="'tinkoff-' + payment.id" outlined class="mb-2">
                            <v-card-text class="py-2">
                              <div class="d-flex justify-space-between align-center">
                                <div>
                                  <div class="subtitle-2">{{ formatAmount(payment.sum / 100) }}</div>
                                  <div class="caption text--secondary">{{ formatDate(payment.created_at) }}</div>
                                  <div v-if="payment.card_number" class="caption text--secondary">{{ payment.card_number }}</div>
                                </div>
                                <v-chip small :color="getTinkoffStatusColor(payment.status)" dark>
                                  {{ payment.status }}
                                </v-chip>
                              </div>
                            </v-card-text>
                          </v-card>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </v-card-text>
            </v-card>
            
            <v-row class="mb-3 mt-2">
              <v-col class="text-center"
                v-if="company && company.tinkoff && company.tinkoff.tinkoff_enabled && client.tinkoff_card_number">
                <h2 class="">
                  {{ $t("tinkoff.card_list") }}:
                </h2>
                <h2 class="subtitle-1 d-flex align-center justify-center mt-3">
                  {{ client.tinkoff_card_number }}
                  <v-icon @click="removeCardCreate()" v-if="client.tinkoff_card_number" class="mx-2"
                    style="cursor: pointer" color="error">
                    mdi-credit-card-remove-outline
                  </v-icon>
                </h2>
              </v-col>
              <v-col class="text-center"
                v-else-if="company && company.tinkoff && company.tinkoff.tinkoff_enabled && !client.tinkoff_card_number">
                <v-btn @click="showRebillDialog = true" class="mx-2" style="cursor: pointer" color="success">
                  {{ $t("transfers.add_card") }}
                  <v-icon class="ml-2">
                    mdi-credit-card-plus-outline
                  </v-icon>
                </v-btn>
              </v-col>
              <!-- <v-col class="text-center" v-else>
                <v-btn class="mx-2" outlined color="primary" v-if="
                  !booking.in_rent &&
                  booking.counts &&
                  booking.counts.length === 0 &&
                  !booking.technical
                ">{{ $t("bookings.pay") }}</v-btn>
                <v-btn class="mx-2" :color="selectColorPaid(booking)" v-if="
                  (booking.counts && booking.counts.length > 0) ||
                  (booking.in_rent && !booking.technical)
                " v-tooltip="{
                  content: `${calculatePayments(booking) != $t('bookings.paid')
                    ? $t('bookings.part_paid')
                    : $t('bookings.full_paid')
                    }`,
                  placement: 'bottom-center',
                  classes: ['info'],
                  targetClasses: ['it-has-a-tooltip'],
                  delay: {
                    show: 500,
                    hide: 500,
                  },
                }">{{ calculatePayments(booking) }}</v-btn>
              </v-col> -->
              <v-col>
                <hr class="mb-2 mt-3" v-if="booking.booking_photos_data && booking.booking_photos_data.length > 0" />
                <booking-photo-gallery v-if="booking.booking_photos_data && booking.booking_photos_data.length > 0" :photos="booking.booking_photos_data"></booking-photo-gallery>
                <hr class="mb-2 mt-3" v-if="
                  booking.generated_documents &&
                  booking.generated_documents.length
                " />
                <h3 class="headline text-center" v-if="
                  booking.generated_documents &&
                  booking.generated_documents.length
                ">
                  {{ $t("bookings.documents") }}
                </h3>
                <v-row class="mt-1" justify="space-around" v-if="!booking.technical">
                  <v-simple-table dense v-if="
                    booking.generated_documents &&
                    booking.generated_documents.length
                  ">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center">
                            {{ $t("custom.created") }}
                          </th>
                          <th class="text-center">
                            {{ $t("bookings.template") }}
                          </th>
                          <th class="text-center">
                            {{ $t('okidoki.status') }}
                          </th>
                          <th class="text-center">
                            {{ $t("bookings.control") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="document in booking.generated_documents" :key="document.index">
                          <td class="text-center">
                            {{ formatCreatedAt(document.created_at) }}
                          </td>
                          <td class="text-center">
                            {{ document.name }}
                          </td>
                          <td class="text-center">
                            <!-- Статус для документов OkiDoki -->
                            <v-chip v-if="document.okidoki_contract_id" 
                              small
                              :color="getOkidokiStatusColor(document.okidoki_status)"
                              text-color="white">
                              <v-icon left small>{{ getOkidokiStatusIcon(document.okidoki_status) }}</v-icon>
                              {{ getOkidokiStatusText(document.okidoki_status) }}
                            </v-chip>
                            <!-- Статус для документов DocuSeal -->
                            <div v-else-if="document.docuseal_submission_id" style="font-size: 12px;">
                              <v-chip small :color="getDocusealStatusColor(document.docuseal_status)" text-color="white">
                                {{ getDocusealDetailedStatusText(document) }}
                              </v-chip>
                            </div>
                            <span v-else>-</span>
                          </td>
                          <td class="text-center">
                            <!-- Кнопки для документов OkiDoki -->
                            <template v-if="document.okidoki_contract_id">
                              <!-- Ссылка на подписание (если не подписан) -->
                              <v-btn icon 
                                v-if="document.okidoki_status !== 'Подписан' && document.okidoki_status !== 'signed' && document.okidoki_link"
                                @click="openSigningLink(document.okidoki_link)"
                                :title="$t('okidoki.open_signing_link')">
                                <v-icon color="purple">mdi-file-sign</v-icon>
                              </v-btn>
                              <!-- Скачать подписанный (если подписан) -->
                              <v-btn icon
                                v-if="(document.okidoki_status === 'Подписан' || document.okidoki_status === 'signed') && document.link"
                                @click="downloadSignedDocBottom(document.download_url || document.link)"
                                :title="$t('okidoki.download_signed')">
                                <v-icon color="green">mdi-file-download</v-icon>
                              </v-btn>
                            </template>
                            
                            <!-- Кнопки для документов DocuSeal -->
                            <template v-else-if="document.docuseal_submission_id">
                              <!-- Кнопка подписания для клиента -->
                              <v-btn icon 
                                v-if="document.docuseal_client_link && !document.docuseal_client_signed_at"
                                @click="openSigningLink(document.docuseal_client_link)"
                                color="primary"
                                :title="$t('docuseal.sign_as_client')">
                                <v-icon>mdi-draw</v-icon>
                              </v-btn>
                              <!-- Просмотр submission (если клиент уже подписал, но документ не завершён) -->
                              <v-btn icon 
                                v-else-if="document.docuseal_client_signed_at && document.docuseal_status !== 'completed' && document.docuseal_link"
                                @click="openSigningLink(document.docuseal_link)"
                                :title="$t('docuseal.view_submission')">
                                <v-icon color="purple">mdi-file-eye</v-icon>
                              </v-btn>
                              <!-- Скачать подписанный PDF (если все подписали) -->
                              <v-btn icon 
                                v-if="document.docuseal_status === 'completed' && document.link"
                                @click="downloadDocusealDocument(document.link)"
                                :title="$t('docuseal.download_signed')">
                                <v-icon color="green">mdi-file-download</v-icon>
                              </v-btn>
                            </template>
                            
                            <!-- Кнопки для обычных документов -->
                            <template v-else>
                              <v-btn icon @click="downloadSignedDocBottom(document.download_url || document.link)">
                                <v-icon>mdi-file-download</v-icon>
                              </v-btn>
                            </template>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-row>
              </v-col>
            </v-row>
          </v-flex>
        </v-flex>
      </v-card-text>
    </v-card>
    
    <v-dialog v-model="showYandexPayDialog" :retain-focus="false" persistent max-width="520px">
      <v-card>
        <v-card-title>{{ $t('yandex_pay.dialog_title') }}</v-card-title>
        <v-card-text>
          <v-alert type="info" dense outlined class="mb-4">
            {{ $t('yandex_pay.dialog_hint_for_client') }}
          </v-alert>
          
          <v-text-field
            v-model="yandexPayAmount"
            :label="$t('yandex_pay.amount')"
            type="number"
            min="0"
            step="0.01"
            outlined
            :disabled="isLoadingYandexPay || yandexPayStatus === 'pending'"
          ></v-text-field>
          
          <v-textarea
            v-model="yandexPayDescription"
            :label="$t('yandex_pay.description_field')"
            rows="1"
            auto-grow
            outlined
            :disabled="isLoadingYandexPay || yandexPayStatus === 'pending'"
          ></v-textarea>
          
          <v-text-field
            v-if="yandexPayPaymentUrl"
            :value="yandexPayPaymentUrl"
            :label="$t('yandex_pay.payment_link_label')"
            readonly
            outlined
            dense
            class="mt-2"
            append-icon="mdi-content-copy"
            @click:append="copyToClipboard(yandexPayPaymentUrl)"
          ></v-text-field>
          
          <div v-if="yandexPayPaymentUrl && yandexPayQrCode" class="text-center mt-4 mb-2">
            <v-card outlined>
              <v-card-text>
                <div class="text-subtitle-2 mb-2">{{ $t('yandex_pay.qr_code_hint') }}</div>
                <img :src="yandexPayQrCode" alt="QR Code" style="max-width: 250px; width: 100%;" />
              </v-card-text>
            </v-card>
          </div>
          
          <v-alert v-if="yandexPayError" type="error" dense outlined class="mt-2">
            {{ yandexPayError }}
          </v-alert>
          
          <v-alert v-if="yandexPayStatus" :type="yandexPayStatusColor(yandexPayStatus)" dense outlined class="mt-2">
            {{ translateYandexPayStatus(yandexPayStatus) }}
          </v-alert>
          
          <div v-if="yandexPayPaymentUrl" class="mt-3 text-center">
            <v-btn small text color="primary" @click="openExternalLink(yandexPayPaymentUrl)">
              <v-icon left small>mdi-open-in-new</v-icon>
              {{ $t('yandex_pay.open_payment') }}
            </v-btn>
          </div>
        </v-card-text>
        
        <v-card-actions class="d-flex justify-space-between">
          <v-btn text @click="closeYandexPayDialog()">{{ $t('custom.close') }}</v-btn>
          <v-btn
            color="success"
            @click="startYandexPayPayment()"
            :loading="isLoadingYandexPay"
            :disabled="isLoadingYandexPay || yandexPayStatus === 'pending' || !!yandexPayPaymentUrl"
          >
            {{ $t('yandex_pay.start_payment') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="showRebillDialog" :retain-focus="false" persistent max-width="1000px">
      <v-card>
        <v-card-title class="text-center">
          {{ $t("tinkoff.adding_card") }}
          <v-spacer></v-spacer>
          <v-icon @click.stop="showRebillDialog = false">
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text>
          <v-flex class="">
            <!-- <v-flex md12 class="pr-5">
              <v-flex class="d-flex">
                <v-text-field v-model.trim="payment_sum" class="mt-5 mr-3" :label="$t('custom.sum')"></v-text-field>
              </v-flex>
            </v-flex> -->
            <v-flex md12 v-if="company && company.tinkoff">
              <p class="text-center subtitle-1">
                <a v-if="company.tinkoff.tarrifs_link" :href="company.tinkoff.tarrifs_link" target="_blank">{{
                  $t("tinkoff.tarrifs_link") }}</a><span v-if="company.tinkoff.tarrifs_link"> | </span>
                <a v-if="company.tinkoff.agreement_link" :href="company.tinkoff.agreement_link" target="_blank">{{
                  $t("tinkoff.agreement_link") }}</a><span v-if="company.tinkoff.agreement_link"> | </span>
                <a v-if="company.tinkoff.privacy_link" :href="company.tinkoff.privacy_link" target="_blank">{{
                  $t("tinkoff.privacy_link") }}</a>
              </p>
            </v-flex>
          </v-flex>
          <p class="text-center">
            {{ $t("tinkoff.payment_for_text") }}
            {{ $t("tinkoff.remove_card_info") }}
          </p>
          <v-checkbox v-model="accept_rebill" class="subtitle-1" hide-details dense
            label="Согласен с условиями использования, тарифами, а так же на обработку персональных данных"></v-checkbox>
          <v-checkbox v-model="accept_rebill_1" class="subtitle-1" hide-details dense
            label="Сохранить карту для дальнейших автоплатежей (продление аренды и других услуг)"></v-checkbox>
        </v-card-text>

        <v-card-actions class="text-center">
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" :disabled="!accept_rebill || !accept_rebill_1" @click="addCardCreate()">{{
            $t("transfers.add_card")
          }}</v-btn>
          <v-btn text
            @click="showRebillDialog = false, payment_sum = 0, accept_rebill = false, accept_rebill_1 = false">{{
              $t("custom.close") }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import BookingPhotoGallery from "./BookingPhotoGallery";
import StripePaymentDialogPublic from "./StripePaymentDialogPublic";
import QRCode from "qrcode";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";
import { copyToClipboard as copyTextToClipboard } from '@/utils/clipboard';
import { s3PublicUrl } from '@/utils/s3PublicUrl';
import { saveAs } from "file-saver";
import moment from "moment";
import "moment/locale/ru";
import "moment/locale/en-gb";
let uuid = require("uuid");
// moment.locale("ru");
import PullToRefresh from "pulltorefreshjs";
import CableSubscriber from "@/mixins/CableSubscriber";
// Залог брони живёт в своём поле для каждого типа аренды
// (deposit / hourly_deposit / weekly_deposit / monthly_deposit).
import { depositFieldFor, bookingDeposit as depositForBooking } from "@/components/dashboard/bookings/addonsMath";
import rentalObjectMixin from "@/mixins/rentalObjectMixin";
export default {
  mixins: [CableSubscriber, rentalObjectMixin],
  data() {
    return {
      booking: null,
      company: null,
      client: null,
      last_name: null,
      booking_id: null,
      prolongsPanel: 0,
      paymentsPanel: 0,
      giftsPanel: 0,
      allPaymentsPanel: null,
      showRebillDialog: false,
      rebill_limit: 100,
      rebill_sum: 500,
      accept_rebill: false,
      accept_rebill_1: false,
      payment_sum: 0,
      isMobile: false,
      isLoading: false,
      error: "",
      stripe_payments: [],
      yandex_pay_payments: [],
      tinkoff_payments: [],
      isStripeChannelSubscribed: false,
      isYandexPayChannelSubscribed: false,
      showYandexPayDialog: false,
      yandexPayAmount: null,
      yandexPayDescription: "",
      yandexPayPaymentUrl: null,
      yandexPayQrCode: null,
      yandexPayStatus: null,
      yandexPayPaymentId: null,
      yandexPayOrderId: null,
      yandexPayError: null,
      isLoadingYandexPay: false,
    };
  },
  mounted() {
    let self = this;
    const ptr = PullToRefresh.init({
      mainElement: "body",
      distIgnore: 100,
      instructionsPullToRefresh: this.$t("custom.pull_to_refresh"),
      instructionsReleaseToRefresh: this.$t("custom.release_to_refresh"),
      instructionsRefreshing: this.$t("custom.refreshing"),
    });
  },
  created() {
    if (this.$route.query.last_name && this.$route.query.booking_id) {
      this.last_name = this.$route.query.last_name;
      this.booking_id = this.$route.query.booking_id;
      this.findBooking();
    }
  },
  beforeDestroy() {
    this.unsubscribeFromYandexPayChannel();
    this.unsubscribeFromStripeChannel();
  },
  computed: {
    progressPercent() {
      if (!this.booking.hourly && !this.booking.weekly && !this.booking.monthly) {
        return (
          (this.calculateRentPaymentsSum(this.booking) /
            ((this.booking.rental_cost - this.booking.aggr_commission) / this.paidDays) /
            this.paidDays) *
          100
        );
      } else if (this.booking.hourly) {
        return (
          (this.calculateRentPaymentsSum(this.booking) /
            ((this.booking.rental_cost - this.booking.aggr_commission) / this.paidHours) /
            this.paidHours) *
          100
        );
      } else if (this.booking.weekly) {
        return (
          (this.calculateRentPaymentsSum(this.booking) /
            ((this.booking.rental_cost - this.booking.aggr_commission) / this.paidWeeks) /
            this.paidWeeks) *
          100
        );
      } else if (this.booking.monthly) {
        return (
          (this.calculateRentPaymentsSum(this.booking) /
            ((this.booking.rental_cost - this.booking.aggr_commission) / this.paidMonths) /
            this.paidMonths) *
          100
        );
      }
      return undefined;
    },
    paidDays() {
      let days =
        Math.round(
          this.calculateRentPaymentsSum(this.booking) /
          (this.booking.rental_cost / this.booking.days)
        ) || this.booking.days;
      if (this.gifts && this.gifts.length > 0) {
        let gift_days = 0;
        let gift_paid = 0;
        this.gifts.forEach((gift) => {
          if (gift.gift_type == 0) {
            gift_days += gift.count;
            gift_paid += gift.count * gift.price;
          }
        });
        let fact_days = days - gift_days;
        days =
          Math.round(
            (this.calculateRentPaymentsSum(this.booking) /
              ((this.booking.rental_cost + gift_paid) / days)) *
            100
          ) / 100;
      }
      return days;
    },
    paidHours() {
      let hours =
        Math.round(
          this.calculateRentPaymentsSum(this.booking) /
          (this.booking.rental_cost / this.booking.hourly_hours)
        ) || this.booking.hourly_hours;
      if (this.gifts && this.gifts.length > 0) {
        let gift_hours = 0;
        let gift_paid = 0;
        this.gifts.forEach((gift) => {
          if (gift.gift_type == 0) {
            gift_hours += gift.count;
            gift_paid += gift.count * gift.price;
          }
        });
        let fact_hours = hours - gift_hours;
        hours =
          Math.round(
            (this.calculateRentPaymentsSum(this.booking) /
              ((this.booking.rental_cost + gift_paid) / hours)) *
            100
          ) / 100;
      }
      return hours;
    },
    paidWeeks() {
      let weeks =
        Math.round(
          this.calculateRentPaymentsSum(this.booking) /
          (this.booking.rental_cost / this.booking.weekly_weeks)
        ) || this.booking.weekly_weeks;
      if (this.gifts && this.gifts.length > 0) {
        let gift_weeks = 0;
        let gift_paid = 0;
        this.gifts.forEach((gift) => {
          if (gift.gift_type == 0) {
            gift_weeks += gift.count;
            gift_paid += gift.count * gift.price;
          }
        });
        let fact_hours = weeks - gift_weeks;
        weeks =
          Math.round(
            (this.calculateRentPaymentsSum(this.booking) /
              ((this.booking.rental_cost + gift_paid) / weeks)) *
            100
          ) / 100;
      }
      return weeks;
    },
    paidMonths() {
      let months =
        Math.round(
          this.calculateRentPaymentsSum(this.booking) /
          (this.booking.rental_cost / this.booking.monthly_months)
        ) || this.booking.monthly_months;
      if (this.gifts && this.gifts.length > 0) {
        let gift_months = 0;
        let gift_paid = 0;
        this.gifts.forEach((gift) => {
          if (gift.gift_type == 0) {
            gift_months += gift.count;
            gift_paid += gift.count * gift.price;
          }
        });
        let fact_hours = months - gift_months;
        months =
          Math.round(
            (this.calculateRentPaymentsSum(this.booking) /
              ((this.booking.rental_cost + gift_paid) / months)) *
            100
          ) / 100;
      }
      return months;
    },
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    checkWriteFile() {
      return Capacitor.isNativePlatform() && Filesystem.checkPermissions();
    },
    requestPermissionsWriteFile() {
      return Filesystem.requestPermissions();
    },
    rental_object() {
      if (this.company && this.company.rental_object) {
        return this.company.rental_object;
      } else {
        return 'cars';
      }
    },
    currency() {
      if (
        this.company &&
        this.company.currency
      ) {
        return this.company.currency;
      } else {
        return "";
      }
    },
    stripeAvailable() {
      return this.company?.stripe_enabled && this.company?.stripe_publishable_key && this.company?.stripe_secret_key;
    },
    yandexPayAvailable() {
      return this.company?.yandex_pay_enabled && this.company?.yandex_pay_api_key && this.company?.yandex_pay_merchant_id;
    },
    currencies() {
      if (
        this.company &&
        this.company.currencies
      ) {
        return this.company.currencies;
      } else {
        return [];
      }
    },
    active_company_cashboxes() {
      if (this.company && this.company.company_cashboxes) {
        let cashboxes = [];
        this.company.company_cashboxes.forEach((cashbox) => {
          if (cashbox.id && cashbox.is_active) {
            cashboxes.push(cashbox);
          }
        });
        cashboxes.sort((a, b) => {
          // сортировка по is_default
          if (a.is_default && !b.is_default) {
            return -1;
          }
        });
        return cashboxes;
      } else {
        return [];
      }
    },
    base_currency_id() {
      if (this.active_company_cashboxes && this.active_company_cashboxes.length > 0) {
        return this.active_company_cashboxes.find((cashbox) => cashbox.is_default).currency_id;
      } else {
        return null;
      }
    },
  },
  methods: {
    bookingDeposit(booking) {
      return depositForBooking(booking);
    },
    async findBooking() {
      if (this.booking_id == '' || this.last_name == '' || this.booking_id == null || this.last_name == null || isNaN(this.booking_id)) {
        if (isNaN(this.booking_id)) {
          this.$notify(this.$t("errors.error"), this.$t("custom.booking_number_is_not_number"), "error", 3000);
          return;
        }
        this.$notify(this.$t("errors.error"), this.$t("custom.no_data"), "error", 3000);
        return;
      }
      this.isLoading = true;
      await this.axios
        .post(`/api/v1/find_booking_for_client_v2`, {
          booking_id: this.booking_id,
          last_name: this.last_name,
        })
        .then((response) => {
          // проверяем что в текущем роуте нет параметров
          if (this.$route.query.last_name == null || this.$route.query.booking_id == null) {
            this.$router.replace({ query: { last_name: this.last_name, booking_id: this.booking_id } })
          }
          if (response.data.error) {
            this.isLoading = false;
            this.$notify(this.$t("errors.error"), this.$t("custom.no_data_in_table"), "error", 3000);
            return;
          }
          // if(this.last_name == null || this.last_name == '' || this.booking_id == null || this.booking_id == '') {
          // this.$router.replace({query: { last_name: this.last_name, booking_id: this.booking_id } })
          // }
          this.booking = response.data.booking;
          this.company = response.data.company;
          this.client = response.data.client;
          this.stripe_payments = response.data.stripe_payments || [];
          this.yandex_pay_payments = response.data.yandex_pay_payments || [];
          this.tinkoff_payments = response.data.tinkoff_payments || [];
          this.isLoading = false;
          
          this.$nextTick(() => {
            this.subscribeToYandexPayChannel();
            this.subscribeToStripeChannel();
          });
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.auth"));
          console.log(error);
        });
    },
    translateBookingState(state) {
      switch (state) {
        case "Новая":
          return this.$t("bookings_states.new");
        case "В обработке":
          return this.$t("bookings_states.in_work");
        case "Недозвон":
          return this.$t("bookings_states.abandoned");
        case "Отказ клиента":
          return this.$t("bookings_states.decline");
        case "Нет машин":
          return this.$t("bookings_states.no_cars");
        case "Ожидает ответа клиента":
          return this.$t("bookings_states.wait_answer");
        case "Активная":
          return this.$t("bookings_states.active");
        case "Отмена":
          return this.$t("bookings_states.cancel");
        case "Отъездила":
          return this.$t("bookings_states.rided");
        case "Вернуть залог":
          return this.$t("bookings_states.return_deposit");
        case "Подтверждена":
          return this.$t("bookings_states.accepted");
        case "Не подтверждена":
          return this.$t("bookings_states.not_accepted");
        case "Другое":
          return this.$t("bookings_states.other");
        default:
          return this.$t("bookings_states.in_work");
      }
    },
    addCardCreate() {
      this.isLoading = true;
      let self = this;
      // Создаём транзакцию у нас
      this.axios
        .post(
          "/api/v1/integrations/tinkoff/add_card",
          {
            client_id: this.client.id,
            current_url: window.location.href,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          if (response.data.Success == true && response.data.PaymentURL) {
            // redirect new window
            window.open(response.data.PaymentURL, "_blank");
          } else {
            this.$notify(response.data.Message, response.data.Details, "error", 5000);
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.setError(error, this.$t("errors.error"));
        })
        .finally(() => (this.isLoading = false));
    },
    removeCardCreate() {
      this.$confirm({
        title: this.$t("tinkoff.remove_card_title"),
        text: this.$t("tinkoff.remove_card_text"),
        icon: "mdi-alert-circle-outline",
        confirmButtonText: this.$t("custom.yes"),
        cancelButtonText: this.$t("custom.no"),
      }).then((result) => {
        if (result) {
          this.isLoading = true;
          // Создаём транзакцию у нас
          this.axios
            .post(
              "/api/v1/integrations/tinkoff/remove_card",
              {
                client_id: this.client.id,
              },
              {
                headers: {
                  Authorization: this.$store.getters.getAuthToken,
                },
              }
            )
            .then(() => {
              this.client.tinkoff_card_number = null;
            })
            .catch((error) => {
              this.isLoading = false;
              this.setError(error, this.$t("errors.error"));
            })
            .finally(() => (this.isLoading = false));
        }
      });
    },
    calculatePayments(booking) {
      if (booking != undefined) {
        let self = this;
        let paid = 0;
        let booking_sum =
          booking.rental_cost +
          booking.delivery +
          booking.delivery_end +
          booking.equipment +
          (booking.addons_cost || 0) + // FT-102 REQ-07: каталожное оборудование

          booking.insurance +
          booking.clean_payment +
          booking.add_drivers_cost +
          booking.hours_cost +
          booking.mileage_cost +
          booking.damage +
          booking.gas +
          booking.fine +
          booking.other +
          booking.other_end +
          booking.hours_cost_end;
        booking.counts.forEach((count) => {
          // если оплата по терминалу и в платеже есть tinkoff_payment_id то учитываем только если count.tinkoff_payment.paid = true
          if (count.completed) {
            if (count.operation) {
              paid += count.sum;
            } else {
              paid -= count.sum;
            }
          }
        });
        // Отнимаем залог у непринятых броней
        if (!booking.ride) {
          booking_sum += booking[depositFieldFor(booking)] || 0;
        }
        if (parseInt(paid) == parseInt(booking_sum)) {
          return self.$t("bookings.paid");
        } else {
          return paid - booking_sum >= 0
            ? `+ ${paid - booking_sum}`
            : ` ${paid - booking_sum}`;
        }
      }
    },
    calculatePaymentsSum(booking) {
      if (booking != undefined) {
        let self = this;
        let paid = 0;
        // Проверяем что значения числовые
        let check_number_rental_cost = Number(booking.rental_cost) === booking.rental_cost;
        let check_number_delivery = Number(booking.delivery) === booking.delivery;
        let check_number_delivery_end = Number(booking.delivery_end) === booking.delivery_end;
        let check_number_equipment = Number(booking.equipment) === booking.equipment;
        let check_number_insurance = Number(booking.insurance) === booking.insurance;
        let check_number_clean_payment = Number(booking.clean_payment) === booking.clean_payment;
        let check_number_add_drivers_cost = Number(booking.add_drivers_cost) === booking.add_drivers_cost;
        let check_number_hours_cost = Number(booking.hours_cost) === booking.hours_cost;
        let check_number_mileage_cost = Number(booking.mileage_cost) === booking.mileage_cost;
        let check_number_damage = Number(booking.damage) === booking.damage;
        let check_number_gas = Number(booking.gas) === booking.gas;
        let check_number_fine = Number(booking.fine) === booking.fine;
        let check_number_other = Number(booking.other) === booking.other;
        let check_number_other_end = Number(booking.other_end) === booking.other_end;
        // FT-102 REQ-07: каталожное оборудование — компонент суммы «к оплате»
        let check_number_addons_cost = Number(booking.addons_cost) === booking.addons_cost;
        let rental_cost = check_number_rental_cost ? booking.rental_cost : 0;
        let delivery = check_number_delivery ? booking.delivery : 0;
        let delivery_end = check_number_delivery_end ? booking.delivery_end : 0;
        let equipment = check_number_equipment ? booking.equipment : 0;
        let insurance = check_number_insurance ? booking.insurance : 0;
        let clean_payment = check_number_clean_payment ? booking.clean_payment : 0;
        let add_drivers_cost = check_number_add_drivers_cost ? booking.add_drivers_cost : 0;
        let hours_cost = check_number_hours_cost ? booking.hours_cost : 0;
        let mileage_cost = check_number_mileage_cost ? booking.mileage_cost : 0;
        let damage = check_number_damage ? booking.damage : 0;
        let gas = check_number_gas ? booking.gas : 0;
        let fine = check_number_fine ? booking.fine : 0;
        let other = check_number_other ? booking.other : 0;
        let other_end = check_number_other_end ? booking.other_end : 0;
        let hours_cost_end = booking.hours_cost_end;
        let addons_cost = check_number_addons_cost ? booking.addons_cost : 0;
        let booking_sum = rental_cost +
          delivery +
          delivery_end +
          equipment +
          addons_cost +
          insurance +
          clean_payment +
          add_drivers_cost +
          hours_cost +
          mileage_cost +
          damage +
          gas +
          fine +
          other +
          other_end +
          hours_cost_end;
        booking.counts.forEach((count) => {
          // если оплата по терминалу и в платеже есть tinkoff_payment_id то учитываем только если count.tinkoff_payment.paid = true
          if (count.completed) {
            if (count.operation) {
              paid += count.sum;
            } else {
              paid -= count.sum;
            }
          }
        });
        // Отнимаем залог у непринятых броней
        if (!booking.ride) {
          booking_sum += booking[depositFieldFor(booking)] || 0;
        }
        return paid;
      }
    },
    calculateRentPaymentsSum(booking) {
      if (booking != undefined) {
        let self = this;
        let paid = 0;
        booking.counts.forEach((count) => {
          if (count.group == "Оплата аренды") {
            if (count.operation) {
              paid += count.sum;
            } else {
              paid -= count.sum;
            }
          }
        });
        return paid;
      }
    },
    findCurrencySymbol(id) {
      if (id != null) {
        if (this.currencies.find((currency) => currency.id == id)) {
          return this.currencies.find((currency) => currency.id == id).symbol;
        }
      }
    },
    selectColorPaid(booking) {
      if (booking != undefined) {
        let paid = 0;
        // Проверяем что значения числовые
        let check_number_rental_cost = Number(booking.rental_cost) === booking.rental_cost;
        let check_number_delivery = Number(booking.delivery) === booking.delivery;
        let check_number_delivery_end = Number(booking.delivery_end) === booking.delivery_end;
        let check_number_equipment = Number(booking.equipment) === booking.equipment;
        let check_number_insurance = Number(booking.insurance) === booking.insurance;
        let check_number_clean_payment = Number(booking.clean_payment) === booking.clean_payment;
        let check_number_add_drivers_cost = Number(booking.add_drivers_cost) === booking.add_drivers_cost;
        let check_number_hours_cost = Number(booking.hours_cost) === booking.hours_cost;
        let check_number_mileage_cost = Number(booking.mileage_cost) === booking.mileage_cost;
        let check_number_damage = Number(booking.damage) === booking.damage;
        let check_number_gas = Number(booking.gas) === booking.gas;
        let check_number_fine = Number(booking.fine) === booking.fine;
        let check_number_other = Number(booking.other) === booking.other;
        let check_number_other_end = Number(booking.other_end) === booking.other_end;
        // FT-102 REQ-07: каталожное оборудование — компонент суммы «к оплате»
        let check_number_addons_cost = Number(booking.addons_cost) === booking.addons_cost;
        let rental_cost = check_number_rental_cost ? booking.rental_cost : 0;
        let delivery = check_number_delivery ? booking.delivery : 0;
        let delivery_end = check_number_delivery_end ? booking.delivery_end : 0;
        let equipment = check_number_equipment ? booking.equipment : 0;
        let insurance = check_number_insurance ? booking.insurance : 0;
        let clean_payment = check_number_clean_payment ? booking.clean_payment : 0;
        let add_drivers_cost = check_number_add_drivers_cost ? booking.add_drivers_cost : 0;
        let hours_cost = check_number_hours_cost ? booking.hours_cost : 0;
        let mileage_cost = check_number_mileage_cost ? booking.mileage_cost : 0;
        let damage = check_number_damage ? booking.damage : 0;
        let gas = check_number_gas ? booking.gas : 0;
        let fine = check_number_fine ? booking.fine : 0;
        let other = check_number_other ? booking.other : 0;
        let other_end = check_number_other_end ? booking.other_end : 0;
        let hours_cost_end = booking.hours_cost_end;
        let addons_cost = check_number_addons_cost ? booking.addons_cost : 0;
        let booking_sum = rental_cost +
          delivery +
          delivery_end +
          equipment +
          addons_cost +
          insurance +
          clean_payment +
          add_drivers_cost +
          hours_cost +
          mileage_cost +
          damage +
          gas +
          fine +
          other +
          other_end +
          hours_cost_end;
        booking.counts.forEach((count) => {
          // если оплата по терминалу и в платеже есть tinkoff_payment_id то учитываем только если count.tinkoff_payment.paid = true
          if (count.completed) {
            if (count.operation) {
              paid += count.sum;
            } else {
              paid -= count.sum;
            }
          }
        });
        // Отнимаем залог у непринятых броней
        if (!booking.ride) {
          booking_sum += booking[depositFieldFor(booking)] || 0;
        }
        if (parseInt(paid) == parseInt(booking_sum)) {
          return "success";
        } else if (paid - booking_sum > 0) {
          return "warning";
        } else if (paid - booking_sum < 0) {
          return "error";
        }
      }
    },
    downloadSignedDocBottom(urlOrLink) {
      // Accepts either a full https URL (preferred, from document.download_url)
      // or a legacy raw S3 key (document.link) for back-compat. Prefer passing
      // document.download_url at call sites.
      if (!urlOrLink) {
        return;
      }
      const url = s3PublicUrl(urlOrLink);
      if (this.isNative) {
        if (Filesystem.checkPermissions()) {
          const getBase64FromUrl = async (fileUrl) => {
            const data = await fetch(fileUrl);
            const blob = await data.blob();
            return new Promise((resolve) => {
              const reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onloadend = () => {
                const base64data = reader.result;
                resolve(base64data);
              }
            });
          }
          getBase64FromUrl(url).then(
            (base64) => {
              // save file
              async function writeFile() {
                return await Filesystem.writeFile({
                  path: `${uuid.v1()}.pdf`,
                  data: base64,
                  directory: Directory.Documents,
                });
              }
              let file_uri = null
              let writedFile = writeFile().then((getUriResult) => {
                // share file opened file
                let shareFile = async () => {
                  await Share.share({
                    title: 'Download document',
                    files: [getUriResult.uri],
                  }).catch((error) => {
                    console.log("shareFile", error)
                  });
                };
                let sharedFile = shareFile();
              }).catch((error) => {
                console.log("shareFile", error)
              });
            }
          );
        } else {
          Filesystem.requestPermissions();
        }
      } else {
        saveAs(url, `${uuid.v1()}.pdf`);
      }
    },
    translateCategory(category) {
      let group_text = "";
      switch (category) {
        case "Оплата аренды":
          group_text = this.$t("groups_counts.rent");
          break;
        case "Доплата за доставку":
          group_text = this.$t("groups_counts.delivery");
          break;
        case "Доплата за приём":
          group_text = this.$t("groups_counts.checkout");
          break;
        case "Доплата за топливо":
          group_text = this.$t("groups_counts.fuel");
          break;
        case "Доплата за мойку":
          group_text = this.$t("groups_counts.clean");
          break;
        case "Доплата за оборудование":
          group_text = this.$t("groups_counts.equipment");
          break;
        case "Доплата за дополнительное время":
          group_text = this.$t("groups_counts.add_time");
          break;
        case "Доплата за повреждения":
          group_text = this.$t("groups_counts.damages");
          break;
        case "Доплата за штрафы":
          group_text = this.$t("groups_counts.fines");
          break;
        case "Доплата за другое":
          group_text = this.$t("groups_counts.other");
          break;
        case "Доплата за превышение пробега":
          group_text = this.$t("groups_counts.mileage");
          break;
        case "Доплата за страховку":
          group_text = this.$t("groups_counts.insurance");
          break;
        case "Доплата за доп водителей":
          group_text = this.$t("groups_counts.add_drivers");
          break;
        case "Ремонт":
          group_text = this.$t("groups_counts.repair");
          break;
        case "Обслуживание":
          group_text = this.$t("groups_counts.service");
          break;
        case "Запчасти":
          group_text = this.$t("groups_counts.parts");
          break;
        case "Страховка":
          group_text = this.$t("groups_counts.insurance_main");
          break;
        case "Накладные расходы":
          group_text = this.$t("groups_counts.common_expences");
          break;
        case "Транспортные расходы":
          group_text = this.$t("groups_counts.transport_expences");
          break;
        case "Налоги":
          group_text = this.$t("groups_counts.tax");
          break;
        case "Штрафы":
          group_text = this.$t("groups_counts.fines_main");
          break;
        case "Аренда имущества":
          group_text = this.$t("groups_counts.rent_property");
          break;
        case "Мойка автомобилей":
          group_text = this.$t("groups_counts.clean_main");
          break;
        case "Топливо":
          group_text = this.$t("groups_counts.fuel_main");
          break;
        case "Реклама":
          group_text = this.$t("groups_counts.ads");
          break;
        case "Зарплата":
          group_text = this.$t("groups_counts.salary");
          break;
        case "Залог":
          group_text = this.$t("groups_counts.deposit");
          break;
        case "Внутренние переводы":
          group_text = this.$t("groups_counts.internal");
          break;
        case "Продажа имущества":
          group_text = this.$t("groups_counts.sell_property");
          break;
        case "Покупка имущества":
          group_text = this.$t("groups_counts.buy_property");
          break;
        case "Прочие расходы":
          group_text = this.$t("groups_counts.other_expences");
          break;
        case "Прочие доходы":
          group_text = this.$t("groups_counts.other_incomes");
          break;
        case "Выплаты партнёрам":
          group_text = this.$t("groups_counts.partners_payments");
          break;
        case "Сервисные сборы":
          group_text = this.$t("groups_counts.service_fees");
          break;
        case "Пополнение баланса клиента":
          group_text = this.$t("groups_counts.top_up_client_balance");
          break;
        case "Выплаты агентам":
          group_text = this.$t("groups_counts.agent_payments");
          break;
      }
      return group_text;
    },
    downloadIcalendar(id) {
      this.axios.get(`/api/v1/bookings/icalendar_file/${id}`, {
        headers: {
          Authorization: this.$store.getters.getAuthToken,
        },
      })
        .then((response) => {
          const blob_data = new Blob([response.data], { type: "text/calendar" });
          if (!this.isNative) {
            saveAs(blob_data, 'booking.ics');
          } else {
            if (Filesystem.checkPermissions()) {
              const getBase64FromBlob = async (blob) => {
                return new Promise((resolve) => {
                  const reader = new FileReader();
                  reader.readAsDataURL(blob);
                  reader.onloadend = () => {
                    const base64data = reader.result;
                    resolve(base64data);
                  }
                });
              }
              getBase64FromBlob(blob_data).then(
                (base64) => {
                  // save file
                  async function writeFile() {
                    return await Filesystem.writeFile({
                      path: 'booking.ics',
                      data: base64,
                      directory: Directory.Documents,
                    });
                  }
                  let file_uri = null
                  let writedFile = writeFile().then((getUriResult) => {
                    // share file opened file
                    let shareFile = async () => {
                      await Share.share({
                        title: 'Download document iCalendar format',
                        files: [getUriResult.uri],
                      }).catch((error) => {
                        console.log("shareFile", error)
                      });
                    };
                    let sharedFile = shareFile();
                  }).catch((error) => {
                    console.log("shareFile", error)
                  });
                }
              );
            } else {
              Filesystem.requestPermissions();
            }
          }
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.error"));
        });
    },
    formatCreatedAt(date) {
      if (date) {
        return moment.parseZone(date).format("DD-MM-YY H:mm");
      } else {
        return "-";
      }
    },
    formatDate(date) {
      if (date) {
        return moment(date).format("DD MMM H:mm");
      } else {
        return "-";
      }
    },
    formatPrologDate(date) {
      return moment.utc(date).format("DD MMM H:mm");
    },
    formatAmount(value) {
      if (!value && value !== 0) {
        return "0.00";
      }
      const numeric = parseFloat(value);
      if (Number.isNaN(numeric)) {
        return value;
      }
      return numeric.toFixed(2);
    },
    getStripeStatusColor(status) {
      if (!status) return "grey";
      const normalized = status.toLowerCase();
      if (normalized === "success") return "success";
      if (normalized === "failed") return "error";
      if (normalized === "cancelled") return "warning";
      if (normalized === "refunded") return "orange";
      if (normalized === "partially_refunded") return "orange";
      return "info";
    },
    translateStripeStatus(status) {
      if (!status) return this.$t("custom.unknown");
      const normalized = status.toLowerCase();
      switch (normalized) {
        case "success":
          return this.$t("stripe_payment.status_success");
        case "failed":
          return this.$t("stripe_payment.status_failed");
        case "cancelled":
          return this.$t("stripe_payment.status_cancelled");
        case "pending":
          return this.$t("stripe_payment.status_pending");
        case "created":
          return this.$t("stripe_payment.status_created");
        case "refunded":
          return this.$t("stripe_payment.status_refunded");
        case "partially_refunded":
          return this.$t("stripe_payment.status_partially_refunded");
        default:
          return status;
      }
    },
    getYandexPayStatusColor(status) {
      if (!status) return "info";
      const normalized = status.toLowerCase();
      if (normalized === "success") return "success";
      if (normalized === "failed") return "error";
      if (normalized === "cancelled") return "warning";
      return "info";
    },
    getTinkoffStatusColor(status) {
      if (!status) return "grey";
      const normalized = status.toString().toUpperCase();
      if (normalized === "CONFIRMED" || normalized === "AUTHORIZED") return "success";
      if (normalized === "REJECTED" || normalized === "REFUNDED") return "error";
      if (normalized === "NEW" || normalized === "AUTHORIZING") return "info";
      return "warning";
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    // Методы для OkiDoki
    getOkidokiStatusColor(status) {
      const statusMap = {
        'draft': 'grey',
        'Черновик': 'grey',
        'awaiting': 'orange',
        'Выставлен': 'orange',
        'signed': 'green',
        'Подписан': 'green',
        'rejected': 'red',
        'Отклонен': 'red',
        'cancelled': 'grey darken-2',
        'Отменен': 'grey darken-2'
      };
      return statusMap[status] || 'blue';
    },
    getOkidokiStatusIcon(status) {
      const iconMap = {
        'draft': 'mdi-file-edit',
        'Черновик': 'mdi-file-edit',
        'awaiting': 'mdi-clock-outline',
        'Выставлен': 'mdi-clock-outline',
        'signed': 'mdi-check-circle',
        'Подписан': 'mdi-check-circle',
        'rejected': 'mdi-close-circle',
        'Отклонен': 'mdi-close-circle',
        'cancelled': 'mdi-cancel',
        'Отменен': 'mdi-cancel'
      };
      return iconMap[status] || 'mdi-file-document';
    },
    getOkidokiStatusText(status) {
      const textMap = {
        'draft': this.$t('okidoki.status_draft'),
        'Черновик': this.$t('okidoki.status_draft'),
        'awaiting': this.$t('okidoki.status_awaiting'),
        'Выставлен': this.$t('okidoki.status_awaiting'),
        'signed': this.$t('okidoki.status_signed'),
        'Подписан': this.$t('okidoki.status_signed'),
        'rejected': this.$t('okidoki.status_rejected'),
        'Отклонен': this.$t('okidoki.status_rejected'),
        'cancelled': this.$t('okidoki.status_cancelled'),
        'Отменен': this.$t('okidoki.status_cancelled')
      };
      return textMap[status] || status;
    },
    // Методы для DocuSeal
    getDocusealStatusColor(status) {
      const statusMap = {
        'pending': 'orange',
        'awaiting': 'orange',
        'completed': 'green',
        'declined': 'red',
        'expired': 'grey darken-2'
      };
      return statusMap[status] || 'blue';
    },
    getDocusealStatusIcon(status) {
      const iconMap = {
        'pending': 'mdi-clock-outline',
        'awaiting': 'mdi-clock-outline',
        'completed': 'mdi-check-circle',
        'declined': 'mdi-close-circle',
        'expired': 'mdi-timer-off'
      };
      return iconMap[status] || 'mdi-file-document';
    },
    getDocusealStatusText(status) {
      const textMap = {
        'pending': this.$t('docuseal.status_pending'),
        'awaiting': this.$t('docuseal.status_awaiting'),
        'completed': this.$t('docuseal.status_completed'),
        'declined': this.$t('docuseal.status_declined'),
        'expired': this.$t('docuseal.status_expired')
      };
      return textMap[status] || status;
    },
    getDocusealDetailedStatusText(document) {
      // Если завершён
      if (document.docuseal_status === 'completed') {
        return this.$t('docuseal.status_completed');
      }
      
      // Если отклонён
      if (document.docuseal_status === 'declined') {
        return this.$t('docuseal.status_declined');
      }
      
      // Если истёк
      if (document.docuseal_status === 'expired') {
        return this.$t('docuseal.status_expired');
      }
      
      // Для pending и awaiting показываем общий статус
      return this.$t('docuseal.status_awaiting');
    },
    openSigningLink(link) {
      window.open(link, "_blank");
    },
    downloadDocusealDocument(link) {
      // Для DocuSeal документов - просто открываем внешнюю ссылку
      // Браузер автоматически предложит скачать PDF
      window.open(link, "_blank");
    },
    
    // Yandex Pay methods
    openYandexPayDialog() {
      if (!this.yandexPayAvailable) {
        this.$notify(this.$t('yandex_pay.not_configured_title'), this.$t('yandex_pay.not_configured_text'), 'warning', 4000);
        return;
      }
      this.yandexPayAmount = null;
      this.yandexPayDescription = '';
      this.yandexPayPaymentUrl = null;
      this.yandexPayQrCode = null;
      this.yandexPayStatus = null;
      this.yandexPayError = null;
      this.yandexPayPaymentId = null;
      this.yandexPayOrderId = null;
      this.showYandexPayDialog = true;
    },

    startYandexPayPayment() {
      const amount = parseFloat((this.yandexPayAmount || '').toString().replace(',', '.'));
      if (!amount || amount <= 0) {
        this.$notify(this.$t('yandex_pay.amount_error'), '', 'warning', 4000);
        return;
      }
      
      this.isLoadingYandexPay = true;
      this.yandexPayError = null;
      this.yandexPayStatus = 'pending';
      
      const payload = {
        booking_id: this.booking_id,
        last_name: this.last_name,
        client_id: this.client.id,
        amount: amount.toFixed(2),
      };
      
      if (this.yandexPayDescription) {
        payload.description = this.yandexPayDescription;
      }
      
      this.axios
        .post('/api/v1/integrations/public_yandex_pays/orders', payload)
        .then((response) => {
          if (!response.data?.payment_url) {
            this.yandexPayStatus = null;
            this.yandexPayError = this.$t('yandex_pay.no_payment_url');
            return;
          }
          
          this.yandexPayPaymentUrl = response.data.payment_url;
          this.yandexPayPaymentId = response.data.payment_id;
          this.yandexPayOrderId = response.data.order_id;
          
          this.generateYandexPayQrCode(this.yandexPayPaymentUrl);
          this.$notify(this.$t('yandex_pay.link_ready_title'), this.$t('yandex_pay.link_ready_text'), 'info', 5000);
        })
        .catch((error) => {
          this.yandexPayStatus = null;
          this.yandexPayError = error.response?.data?.error || error.message || this.$t('yandex_pay.status_error');
        })
        .finally(() => {
          this.isLoadingYandexPay = false;
        });
    },

    closeYandexPayDialog() {
      this.showYandexPayDialog = false;
      this.yandexPayAmount = null;
      this.yandexPayDescription = '';
      this.yandexPayPaymentUrl = null;
      this.yandexPayQrCode = null;
      this.yandexPayStatus = null;
      this.yandexPayPaymentId = null;
      this.yandexPayOrderId = null;
      this.yandexPayError = null;
    },

    generateYandexPayQrCode(url) {
      if (!url) {
        this.yandexPayQrCode = null;
        return;
      }
      
      QRCode.toDataURL(url, { width: 250, margin: 2 })
        .then(dataUrl => {
          this.yandexPayQrCode = dataUrl;
        })
        .catch(err => {
          console.error('QR code error:', err);
          this.yandexPayQrCode = null;
        });
    },

    // WebSocket handlers
    handleYandexPayUpdate(data) {
      if (!data?.yandex_pay_payment) return;
      
      const payment = data.yandex_pay_payment;
      if (this.yandexPayPaymentId && payment.id !== this.yandexPayPaymentId) return;
      
      this.yandexPayStatus = payment.status;
      
      if (payment.status === 'success') {
        this.$notify(this.$t('yandex_pay.success_message'), '', 'success', 4000);
        this.findBooking();
        this.closeYandexPayDialog();
      } else if (payment.status === 'failed') {
        this.yandexPayError = this.$t('yandex_pay.failed_message');
      } else if (payment.status === 'cancelled') {
        this.yandexPayError = this.$t('yandex_pay.cancelled_message');
      }
    },

    handleStripePaymentUpdate(data) {
      if (this.$refs.stripePaymentDialog) {
        this.$refs.stripePaymentDialog.handlePaymentUpdate(data);
      }
      
      if (data?.stripe_payment?.status === 'success') {
        this.findBooking();
      }
    },

    handleStripePaymentsUpdated() {
      this.findBooking();
    },

    // WebSocket subscription (FT-066: native held-ref objects + id-aware switch pattern).
    // NB: ClientPage genuinely re-resolves this.client on a LIVE instance — findBooking() runs
    // from the search form with a different booking/last_name → a DIFFERENT client. So the
    // id-aware switch is a real correctness fix here (not just a safety-net): the old flag-only
    // guard would have kept the prior client's subscription and dropped the new client's events.
    subscribeToYandexPayChannel() {
      if (!this.client?.id || !this.yandexPayAvailable) return;
      // no-op if already on THIS client (dedup); re-subscribe if the client id changed.
      if (this.isYandexPayChannelSubscribed && this.yandexSubClientId === this.client.id) return;
      this.$cableUnsubscribe(this.yandexSub);
      // received → handleYandexPayUpdate (this-rebinding via arrow). Mixin auto-unsubscribes too.
      this.yandexSub = this.$cableSubscribe(
        { channel: 'YandexPayPaymentChannel', client_id: this.client.id },
        { received: (data) => this.handleYandexPayUpdate(data) }
      );
      this.yandexSubClientId = this.client.id;
      this.isYandexPayChannelSubscribed = true;
    },

    unsubscribeFromYandexPayChannel() {
      if (this.isYandexPayChannelSubscribed) {
        this.$cableUnsubscribe(this.yandexSub);
        this.yandexSub = null;
        this.yandexSubClientId = null;
        this.isYandexPayChannelSubscribed = false;
      }
    },

    subscribeToStripeChannel() {
      if (!this.client?.id || !this.stripeAvailable) return;
      // card↔dialog collision fix: own held StripePaymentChannel object. no-op on same client;
      // re-subscribe if the client id changed. received → handleStripePaymentUpdate (forwards to dialog).
      if (this.isStripeChannelSubscribed && this.stripeSubClientId === this.client.id) return;
      this.$cableUnsubscribe(this.stripeSub);
      this.stripeSub = this.$cableSubscribe(
        { channel: 'StripePaymentChannel', client_id: this.client.id },
        { received: (data) => this.handleStripePaymentUpdate(data) }
      );
      this.stripeSubClientId = this.client.id;
      this.isStripeChannelSubscribed = true;
    },

    unsubscribeFromStripeChannel() {
      if (this.isStripeChannelSubscribed) {
        this.$cableUnsubscribe(this.stripeSub);
        this.stripeSub = null;
        this.stripeSubClientId = null;
        this.isStripeChannelSubscribed = false;
      }
    },

    // Utilities
    async copyToClipboard(value) {
      if (!value) return;
      
      try {
        await copyTextToClipboard(value);
        this.$notify(this.$t('yandex_pay.copy_success'), '', 'success', 3000);
      } catch (error) {
        this.$notify(this.$t('yandex_pay.copy_failed'), '', 'error', 3000);
      }
    },

    openExternalLink(url) {
      if (url) window.open(url, '_blank');
    },

    translateYandexPayStatus(status) {
      if (!status) return this.$t('yandex_pay.status_unknown');
      const normalized = status.toLowerCase();
      const statusMap = {
        success: 'yandex_pay.status_success',
        failed: 'yandex_pay.status_failed',
        cancelled: 'yandex_pay.status_cancelled',
        pending: 'yandex_pay.status_pending',
        created: 'yandex_pay.status_created',
      };
      return this.$t(statusMap[normalized] || 'yandex_pay.status_unknown');
    },

    yandexPayStatusColor(status) {
      if (!status) return 'info';
      const normalized = status.toLowerCase();
      if (normalized === 'success') return 'success';
      if (normalized === 'failed') return 'error';
      if (normalized === 'cancelled') return 'warning';
      return 'info';
    },
  },
  components: {
    BookingPhotoGallery,
    StripePaymentDialogPublic,
  }
};
</script>
